
const NotFound = () => {
    return (<>
        <p className='langtitle'>Page not found</p>
    </>)
};

export default NotFound;